<template>
  <div class="language-container">
    <div class="control-row p-error head" >
      {{$t('message.select_language_title')}}
    </div>

    <div class="language-list">
      <div class="control-row justify-row-between"  v-for="(value, key) in languages" v-bind:key="key">
        <div class="message">
          {{value}}
        </div>
        <RadioButton v-model="language" name="lng" :value="key" />
      </div>
    </div>
    
    <div class="control-row" >
        <Button :label="$t('message.ok')" @click="selectlanguage()" class="full-width" />
    </div>   
  </div>
</template>

<script>
import RadioButton from 'primevue/radiobutton';
import Button from 'primevue/button';

export default {
  name: 'SelectLanguage',
  inject: ['dialogRef'],
  components: {
    RadioButton,
    Button
  },
  data(){
    return {
      language:'hant',
      qrlanguage:null,
      languages:{}
    }
  },
  props: {
  },
  methods:{

    selectlanguage(){

      this.$i18n.locale=this.language;

      if(this.$common.version==this.$common.E88)
        this.$common.TITLE=this.$t('message.title_88E');
      else
        this.$common.TITLE=this.$t('message.title_top_qr');

      this.dialogRef.close();

    }

  },
  created(){
    
    this.language=this.$i18n.locale;

    this.qrlanguage=this.dialogRef.data.qrlanguage;

    for(var i=0; i<this.qrlanguage.value.length; i++){

      for(var key in this.$common.languages){

        if(this.qrlanguage.value[i]==key){

          this.languages[key]=this.$common.languages[key];

          break;

        }
      }

    }

    var lng_in_list=false;

    var firstelement=null;

    var index=0;

    for(var k in this.languages){

      if(index++==0)
        firstelement=k;

      if(this.language==k){

        this.language=k;

        lng_in_list=true;

        break;

      }

    }

    if(!lng_in_list){

      this.language=firstelement;

    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.language-container{
  height:100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:1rem 3rem;
}
.language-container:last-child{
  margin-bottom: 0px;
}

.language-list{
  max-width: 80vh;
  overflow-y: scroll;
  width:100%;
}
.control-row{
  margin-bottom: 1rem;
  text-align:left;
  width:100%;
}
.justify-row-between{
  display: flex;
  justify-content: space-between;
}
.message{
  margin-top:5px;
}
.full-width{
  width:100%;
}

.head{
  text-align: center;
}
</style>